export const ganChiTitle = "gan-chi-title";
